import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import api from '../config/axios';
import SectionCard from './ui/SectionCard';

const formatWhen = (value) => {
  if (!value) return '—';
  const raw = String(value);
  const date = new Date(raw.includes('T') ? raw : `${raw.replace(' ', 'T')}Z`);
  if (Number.isNaN(date.getTime())) return raw;
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone: 'America/Sao_Paulo',
    hourCycle: 'h23',
  }).format(date);
};

export default function DevOtpInbox() {
  const [visible, setVisible] = useState(false);
  const [notice, setNotice] = useState('');
  const [messages, setMessages] = useState([]);
  const [copied, setCopied] = useState('');

  const load = useCallback(async () => {
    try {
      const response = await api.get('/hackathon/admin/dev-email/outbox');
      setVisible(true);
      setNotice(response.data?.notice || 'Somente desenvolvimento — nenhum e-mail real foi enviado.');
      setMessages(response.data?.messages || []);
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404 || status === 403) {
        setVisible(false);
        return;
      }
      setVisible(true);
      setNotice('Não foi possível ler a caixa de desenvolvimento.');
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (!visible) return null;

  const copyCode = async (code) => {
    await navigator.clipboard.writeText(code);
    setCopied(code);
  };

  return (
    <SectionCard>
      <Stack spacing={1.5}>
        <Typography variant="h3" component="h2">Caixa OTP de desenvolvimento</Typography>
        <Alert severity="warning">{notice}</Alert>
        <Button variant="outlined" onClick={load} sx={{ alignSelf: 'flex-start' }}>
          Atualizar caixa
        </Button>
        {messages.length === 0 ? (
          <Typography color="text.secondary">Nenhum código nesta sessão do servidor.</Typography>
        ) : messages.map((message) => (
          <Stack
            key={`${message.to}-${message.createdAt}-${message.code}`}
            spacing={0.5}
            sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 1.5 }}
          >
            <Typography>E-mail: {message.to}</Typography>
            <Typography sx={{ fontFamily: 'monospace', fontSize: '1.25rem' }}>Código: {message.code || '—'}</Typography>
            <Typography color="text.secondary">Criado em: {formatWhen(message.createdAt)}</Typography>
            <Typography color="text.secondary">Expira em: {formatWhen(message.expiresAt)}</Typography>
            <Button
              variant="contained"
              disabled={!message.code}
              onClick={() => copyCode(message.code)}
              sx={{ alignSelf: 'flex-start' }}
            >
              {copied === message.code ? 'Código copiado' : 'Copiar código'}
            </Button>
          </Stack>
        ))}
      </Stack>
    </SectionCard>
  );
}
